import { APP_PATH } from 'modules/app/constants'
import { getObjectUtil } from 'packages/src'

const getRenderCountAppSelect = state => getObjectUtil(state, APP_PATH.RENDER_COUNT)

export default getRenderCountAppSelect
